module.exports = __webpack_public_path__ + "img/lxkf.bfff6ee2.svg";